// Micro template engine — soporta {{var}}, {{nested.path}}, {{#each arr}}...{{/each}}

function resolvePath(obj, path) {
  return path.split('.').reduce((o, k) => (o != null ? o[k] : undefined), obj);
}

export function render(template, data) {
  let html = template.replace(
    /\{\{#each\s+([\w.]+)\}\}([\s\S]*?)\{\{\/each\}\}/g,
    (_, key, inner) => {
      const arr = resolvePath(data, key) ?? [];
      return arr.map(item => render(inner, { ...data, ...item, _item: item })).join('');
    }
  );
  html = html.replace(/\{\{([\w.]+)\}\}/g, (_, path) => {
    const val = resolvePath(data, path);
    return val != null ? String(val) : '';
  });
  return html;
}

export function printDocument(html) {
  const iframe = document.createElement('iframe');
  iframe.style.cssText =
    'position:fixed;top:-9999px;left:-9999px;width:0;height:0;border:0';
  document.body.appendChild(iframe);

  const doc = iframe.contentDocument || iframe.contentWindow.document;
  doc.open();
  doc.write(html);
  doc.close();

  iframe.contentWindow.focus();
  setTimeout(() => {
    iframe.contentWindow.print();
    setTimeout(() => {
      if (document.body.contains(iframe)) document.body.removeChild(iframe);
    }, 1500);
  }, 350);
}
